/* AONSK cart operations: one server mutation/render at a time. */
(() => {
  if (window.aonskCartQueue) return;
  let tail = Promise.resolve();
  window.aonskCartQueue = {
    run(operation) {
      const result = tail.then(operation);
      // A failed operation must not poison later attempts. Never retry an add automatically.
      tail = result.catch(() => {});
      return result;
    }
  };
})();

/* Cross-tab cart invalidation; the signal contains no cart/customer data. */
(() => {
  const key = "aonsk-cart-changed";
  let timer, latest = "";
  function publish() {
    try { localStorage.setItem(key, String(Date.now()) + ":" + Math.random()); } catch (_) {}
  }
  function refreshPageNotice(page) {
    if (page.querySelector("[data-cart-other-tab]")) return;
    const notice = document.createElement("div");
    notice.dataset.cartOtherTab = "true";
    notice.setAttribute("role", "status");
    notice.style.cssText = "margin:0 0 1.5rem;padding:1rem;border:1px solid currentColor;border-radius:6px";
    const message = document.createElement("p");
    message.textContent = "Your cart changed in another tab. Refresh it before checking out.";
    const button = document.createElement("button");
    button.type = "button";
    button.className = "btn btn--primary";
    button.textContent = "Refresh cart";
    button.addEventListener("click", () => window.location.reload());
    notice.append(message, button);
    page.prepend(notice);
    // Leave customer notes intact until they choose to reload.
    page.querySelectorAll('[name="checkout"]').forEach(control => { control.disabled = true; });
    page.querySelectorAll(".additional-checkout-buttons").forEach(control => { control.hidden = true; });
    const guard = event => {
      if (event.type === "submit" || event.target.closest('[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        button.focus();
      }
    };
    page.addEventListener("submit", guard, true);
    page.addEventListener("click", guard, true);
  }
  function refresh() {
    if (window.__aonskCheckoutIntentActive) return;
    const page = document.querySelector(".cc-main-cart");
    if (page) { refreshPageNotice(page); return; }
    const drawer = document.getElementById("cart-drawer");
    if (drawer && typeof drawer.refreshCartDrawer === "function") {
      Promise.resolve(drawer.refreshCartDrawer()).catch(() => {});
    }
  }
  window.addEventListener("storage", event => {
    if (event.key !== key || !event.newValue || event.newValue === latest) return;
    latest = event.newValue;
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 100);
  });
  document.addEventListener("on:cart:add", publish);
  document.addEventListener("on:line-item:change", publish);
  document.addEventListener("on:cart:change", publish);
})();
